export default __webpack_public_path__ + "../img/f82d8e084741ad1419168444be1531b0.png";